<template>
  <div v-if="refresh" class="sa-h100" :class="minMaxPanel ? 'sa-d-f-sbetween' : ''">

    <div class="sa-chat-hdr" v-if="headerPanel" :class="videoMinimised ? 'sa-d-none' : ''">
      <div class="sa-chat-hdr-lft" @click="$router.go(-1)">
        <i class="icon-left-arrow sa-h-sm-up"></i>
        <figure class="sa-avtar sa-avtar-md sa-h-xs">
          <img v-if="pimg" :src="pimg" alt="Doctor" class="sa-img-cover" />
          <img
            v-else
            :src="unknownImg"
            alt="Doctor"
            class="sa-img-cover"
          />
        </figure>
        <span class="sa-online sa-h-xs"></span>
        <div class="sa-chat-tit sa-h-xs">
          {{ pname }}
          <small>Online</small>
        </div>
      </div>
      <div class="sa-chat-hdr-rgt">
        <ul class="sa-chat-list">
          <li @click="startCall">
            <i class="icon-video sa-primary-text"></i>
          </li>
          <li @click="$router.go(-1)">
            <i class="icon-turnoff sa-pink-text"></i>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="sa-chat-card"
      :class="videoMinimised ? 'sa-minimize' : ''"
      v-if="chatPanel"
    >
      <div class="sa-chat-history" ref="chatArea">
        <div class="sa-chat-about">
          <figure class="sa-avtar sa-avtar-sm">{{ nameCaps(pname) }}</figure>
          {{ pname }}
          <!-- <small>Seems like the other end is on offline. So please wait for some time and <span class="sa-d-block">your chat will start shortly.</span></small> -->
        </div>
        <div
          v-for="(msg, index) in chatMsgs"
          :key="index"
        >
          <!-- {{msg}} -->

        <div 
        v-if=" msg.msg_type != 'event'"
         :class="
            msg.from == userInfo.uid
              ? 'sa-chat-msg sa-msg-doc'
              : 'sa-chat-msg sa-msg-pat'
          ">
          <figure
            class="sa-avtar sa-avtar-xs sa-h-xs"
            v-if="msg.from == userInfo.uid"
          >
            <img
              v-if="docImage"
              :src="docImage"
              alt="Doctor"
              class="sa-img-cover"
            />
            <img
              v-else
              :src="unknownImg"
              alt="Doctor"
              class="sa-img-cover"
            />
          </figure>
          <figure class="sa-avtar sa-avtar-xs sa-h-xs" v-else>
            <img v-if="pimg" :src="pimg" alt="Doctor" class="sa-img-cover" />
            <img
              v-else
              :src="unknownImg"
              alt="Doctor"
              class="sa-img-cover"
            />
          </figure>
          <span
            v-if="!(msg.from == userInfo.uid)"
            class="sa-online sa-online-small"
          ></span>
          <div class="sa-chat-msg-info">
            <div class="sa-chat-time">{{ chatTime(msg.created_at) }}</div>
            <div>
            
          </div>
            <div v-if="!msg.file_type&&msg.msg_type != 'event'" class="sa-chat-msg-text">
              {{ msg.body }}
            </div>
                    <a :href="msg.body" class="sa-chat-msg-text sa-chat-msg-img" target="_blank" v-else-if="msg.file_type">
                      <img :src="msg.body" class="sa-img-cover" v-if="isImage(getFileExtension(msg.file_type))" />
                      <i :class="`icon-${getFileExtension(msg.file_type).toLowerCase()}`" class=" h2" v-else></i>
                  </a>
            <a
              v-else-if="msg.msg_type != 'event'"
              :href="msg.body"
              target="_blank"
              class="sa-chat-msg-text"
              >{{ msg.body }}</a
            >
            
          </div>
        </div>
        <div v-if="msg.msg_type === 'event'" class="sa-chat-log">
              <span class="sa-call-log-brd">
                <span class="sa-black-text">{{!msg.duration ? msg.call_log : 'Call' }} </span>
                <span v-if="msg.duration" class="sa-blue-text">{{msg.call_log}}</span>
                <span class="sa-d-block">{{chatTime(msg.created_at)}}</span>
              </span>
            </div>
        </div> 
      </div>
      <video-call />
      <div class="sa-chat-footer">
        <input
          type="text"
          @keyup.enter="sendMessage"
          class="sa-chat-input"
          v-model="msgText"
          placeholder="Enter your message..." id="msgText" name="msgText"
        />
        <!-- <button type="submit" class="sa-btn sa-chat-btn sa-chat-attach"><i class="icon-attachment"></i></button> -->
        <chat-attachment
          :triggerCancel="triggerCancel"
          v-on:file-upload-success="setImg($event)"
        />
        <button @click="sendMessage" class="sa-btn sa-chat-btn">
          <i class="icon-send"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
} from "twilio-video";
import io from "socket.io-client";
import uniqid from "uniqid";
import { com_url, socket_url, pro_url } from "../../../config/endpoints";
import moment from "moment";
import chatAttachmentVue from "../common/chatAttachment.vue";
import async from "async";
import _ from "lodash";
import { bus } from "../../main"
const VideoCall = () => import(/* webpackChunkName: "videocall" */ "../video-call/VideoCall.vue");
export default {
  components: {
    "chat-attachment": chatAttachmentVue,
    // Ringer,
    VideoCall
  },
  props: ['callflag'],
  mounted() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || null;
    if (_self.userInfo) {
      _self.docImage = _self.userInfo.img;
    }
    _self.appDetails =
      JSON.parse(_self.$localStorage.get("appDetails")) || null;

    if (_self.appDetails) {
      _self.pname = _self.appDetails.pname || null;
      _self.appId = _self.appDetails.apnt_id || null;
      _self.pimg = _self.appDetails.img;
    }
    if (_self.$route.params.appid) {
      _self.appId = _self.$route.params.appid
    }
    async.parallel(
      [
        _self.socketInit.bind(),
        _self.createRoom.bind(),
        _self.fetchMessages.bind(),
        _self.appData.bind()
      ],
      function () {}
    );

    // agora changses
    bus.$on('endCall', this.endCall);
    this.$on('minimized', () => {
        _self.minimized = !_self.minimized
    })
  },
  data() {
    return {
      msgText: null,
      diallerStartTime: null,
      callstartflag: false,
      appEndTime: null,
      presentTime: null,
      sessionTime: null,
      innerTime: null,
      appDetails: null,
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
        "HEVC",
        "HEIC",
        "HGIF",
        "svg",
        "jfif"
      ],
      docImage: null,
      trackaddvc:null,
      trackEnabledval:false,
      refresh:true,
      disconnected:false,
      pimg: null,
      pname: null,
      doctorToken: null,
      patientToken: null,
      triggerCancel: false,
      appId: null,
      msgTextflag: false,
      file_type: null,
      userInfo: null,
      chatMsgs: [],
      socket: null,
      socketId: null,
      localTrack: false,
      remoteTrack: "",
      fullImageModal: false,
      chatSessionEnd: false,
      headerPanel: true,
      videoPanel: false,
      chatPanel: true,
      minMaxPanel: false,
      fullVideoPanel: false,
      roomName: null,
      token: null,
      activeRoom: null,
      dialer: false,
      hideMic: false,
      showMic: true,
      muteMic: false,
      unMuteMic: false,
      hideVideo: false,
      showVideo: true,
      onVideo: false,
      offVideo: false,
      muteLocParticipant: false,
      hideLocParticipant: false,
      minMaxFlag: false,
      screenSize: false,
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",

      // agora changes
      // ringer: false,
    };
  },
  computed: {
    videoMinimised() {
      return this.$store.getters.videoMinimised
    },
  },
  methods: {
     getFileExtension(fileName) {
                let fileType = fileName.split(".").pop();
                return fileType;
            },
            isImage(ext) {
                if(!ext){
                    return false;
                }
                const imgFtypes = ["jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "eps","svg","raw","jfif"]
                return imgFtypes.indexOf(ext) !== -1;
            },
    calculateDial: function () {
      let _self = this;
      if (moment().diff(this.diallerStartTime, "seconds") > 25) {
        clearInterval(_self.dialInterval);
        clearInterval(_self.callInterval);
        clearInterval(_self.interval);
        _self.disconnectCall();
      }
    },
    createRoom: function (callback) {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/socket/createRoom`,
          body: {
            uid: _self.appDetails.sanar_uid,
            doc_id: _self.userInfo.uid,
            roomName: _self.appDetails.apnt_id,
          },
        })
        .then((data) => {
          return callback();
        });
    },
    socketInit(callback) {
      let _self = this;
      let did = uniqid();
      _self.socket = io(socket_url, {
          query: `uid=${_self.userInfo.uid}&did=${did}`,
           transports: ['websocket']
        });
        // _self.socket = _.cloneDeep(this.$store.getters['getSocket'])
        console.log(_self.socket,'socket data from video component');
      if (_self.socket) {
        _self.socket.on("connect", () => {
          console.log('connect in video component');
          _self.socketId = _self.socket.id;
        });
        _self.socket.on("disconnect", function () {
          console.log('disconnect in video component');
          // disconnecting socket here
        });
        // listening incoming messages event
        _self.socket.on("INCOMING_MESSAGE", (messageData) => {
          _self.msgTextflag = true;
          if (messageData && messageData.chatroom_id == _self.appId) {
            messageData["created_date"] = moment().format();
            _self.chatMsgs.push(messageData);
            setTimeout(() => {
              let msgDsp = _self.$refs.chatArea;
              if(typeof msgDsp != 'undefined' ){
                msgDsp.scrollTop = msgDsp.scrollHeight;
              }
            }, 500);
          }
        });
        this.socket.on("CALL_ACCEPTED", this.onCallAccept);
        this.socket.on("CALL_REJECTED", this.endCall());
      }
      return callback();
    },
    userMedia: function (callback) {
      let permissionGranted = false
      let webKitPermission = function(lcallback){
        if (typeof navigator != "undefined" && navigator.webkitGetUserMedia) {
          navigator.webkitGetUserMedia(
            { video: true, audio: true },
            function success() {
              permissionGranted = true
              //alert("audio video permissions granted");
              return lcallback();
            },
            function error() {
              // alert("audio video permission error");
              return lcallback();
            }
          );
        } else {
          // alert("does not support webRTC");
          return lcallback();
        }
      }
      let mediaDevicePermission = function(lcallback){
        if (!permissionGranted && typeof navigator != "undefined" && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)  {
          navigator.mediaDevices.getUserMedia(
            { video: true, audio: true },
            function success() {
              permissionGranted = true
              // alert("audio video permissions granted");
              return lcallback();
            },
            function error() {
              // alert("audio video permission error");
              return lcallback();
            }
          );
        } else {
          // alert("does not support webRTC");
          return lcallback();
        }
      }
      async.series([
        webKitPermission.bind(),
        mediaDevicePermission.bind()
      ], function(){
        return callback()
      })
    },
    async rejectCallNew() {
      console.log("running callllllllll disconnect");
       let _self = this;
            // let duration = {
            //     duration: _self.timer
            // }
            let videoTrack = _self.activeRoom&&_self.activeRoom.localParticipant&&[..._self.activeRoom.localParticipant.videoTracks.values()]
            if(videoTrack != null) {
              await videoTrack.forEach(publication => {
                clearVideo(publication.track)
            })
            }
            async function clearVideo(track) {
                await track.stop();
                await _self.activeRoom.disconnect()
            }
            setTimeout(() => {
                console.log("timeout running")
                let videoTrack = [..._self.activeRoom.localParticipant.videoTracks.values()]
                videoTrack.forEach(publication => {
                    publication.track.unpublishTrack(publication)
                    publication.track.stop()
                    _self.activeRoom = null
                })
            }, 7000);
    },
    increaseTime() {
      let _self = this;
      //_self.innerTime = "00:01";
      _self.innerTime = moment(_self.innerTime, "mm : ss").add(1, 'seconds').format("mm : ss");
      let check_dt = moment(_self.appEndTime).subtract(1, 'minutes').format('hh:mm');
      let call_dt = moment(_self.appEndTime).add(10, 'minutes').format('hh:mm');
      let end_dt = moment(_self.appEndTime).format('hh:mm')
      //checking before 1 minute appointment end time 
      if(check_dt == moment().format('hh:mm')){
      _self.$parent.disconnectPopup = true
      if(_self.$parent.popflag){
         _self.$parent.disconnectPopup = false
      }
      }
       //checking call continue or not 
        if(_self.callflag){
          if(call_dt == moment().format('hh:mm')){
            _self.disconnectCall();
          }
        } else {
          if(end_dt == moment().format('hh:mm')){
            _self.disconnectCall();
          }
        }
    },
    isImage(fileType) {
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    rejectedCall() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/socket/reject_video_call_v1`,
          body: {
            uid: _self.appDetails.sanar_uid,
            apnt_id:_self.appDetails.apnt_id
          },
        })
        .then((data) => {
          _self.leaveRoomIfJoined();
          _self.videoPanel = false;
          _self.chatPanel = true;
          _self.headerPanel = true;
          _self.minMaxPanel = false;
          _self.minMaxFlag = false;
        });

    },
    showLocalParticipant() {
      let _self = this;
        _self.showVideo = !_self.showVideo;
        _self.offVideo = !_self.offVideo;
      if (_self.activeRoom) {
        if (!_self.hideLocParticipant) {
          _self.activeRoom.localParticipant.videoTracks.forEach(
            (publication) => {
              if (publication)
              publication.track.disable();
              _self.hideLocParticipant = true;
            }
          );
        } else {
          _self.activeRoom.localParticipant.videoTracks.forEach(
            (publication) => {
              if (publication)
              publication.track.enable();
              _self.hideLocParticipant = false;
            }
          );
        }
      }
    },
    muteLocalParticipant() {
      let _self = this;
        _self.showMic = !_self.showMic;
        _self.muteMic = !_self.muteMic;
      if (_self.activeRoom) {
        if (!_self.muteLocParticipant) {
          _self.activeRoom.localParticipant.audioTracks.forEach(
            (publication) => {
              if (publication)
              publication.track.disable();
              _self.muteLocParticipant = true;
            }
          );
        } else {
          _self.activeRoom.localParticipant.audioTracks.forEach(
            (publication) => {
              if (publication)
              publication.track.enable();
              _self.muteLocParticipant = false;
            }
          );
        }
      }
    },
    async disconnectCall(val) {
      this.$store.dispatch("SET_NAVIGATE", true);
      this.leaveRoomIfJoined();
      await this.rejectCallNew()
      this.videoPanel = false;
      this.chatPanel = true;
      this.headerPanel = true;
      this.minMaxPanel = false;
      this.minMaxFlag = false;
      this.refresh = false
      this.showVideo = true
      this.offVideo = true
      this.hideLocParticipant = false;
      this.muteLocParticipant = false
      this.showMic = true;
      setTimeout(() => {
        this.refresh = true
      }, 300);
      clearInterval(this.interval);
      clearInterval(this.dialInterval);
      clearInterval(this.callInterval);
      let _self = this
      this.rejectedCall()
      if(!_self.callstartflag&&val){
        console.log(_self.innerTime,"_self.innerTime_self.innerTime");
         this.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/socket/reject_video_call_v1`,
          body: {
            uid: _self.appDetails.sanar_uid,
            apnt_id:_self.appDetails.apnt_id,
            isMissedCall: true,
            duration: _self.innerTime != null ? "00 : " + _self.innerTime : undefined,
            roomName:_self.appDetails.apnt_id
          },
          
        })
        .then((data) => {
          _self.leaveRoomIfJoined();
          _self.videoPanel = false;
          _self.chatPanel = true;
          _self.headerPanel = true;
          _self.minMaxPanel = false;
        });
      }
      setTimeout(() => {
              let msgDsp = _self.$refs.chatArea;
              if(typeof msgDsp != 'undefined' )
                msgDsp.scrollTop = msgDsp.scrollHeight;
            }, 500);
      _self.callstartflag = false
    },
    setImg(uimg, flag) {
      let _self = this;
      if (uimg && uimg.filename) {
        _self.file_type = uimg.filename.split(".")[1] || null;
      }
      if (uimg && uimg.url) {
        _self.msgText = uimg.url;
      }
    },
    // Leave Room.
    leaveRoomIfJoined() {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
      }
    },
    twilioAPI() {
      let _self = this;
      _self.userMedia()
      _self.dialer = false;
      _self.roomName = _self.appId;
      let token = _self.doctorToken;
      //   const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTS2RhODJiMjcyMzNhZjZlOTI2NmMwN2U3MDg0NDI5YmM5LTE1OTMxMDc5NDkiLCJncmFudHMiOnsiaWRlbnRpdHkiOiJoYXJpIiwidmlkZW8iOnt9fSwiaWF0IjoxNTkzMTA3OTQ5LCJleHAiOjE1OTMxMTE1NDksImlzcyI6IlNLZGE4MmIyNzIzM2FmNmU5MjY2YzA3ZTcwODQ0MjliYzkiLCJzdWIiOiJBQzhhYjNlMjczMThjOGE1YjQ0MTNkNDc0ODE3ZDZkYTBjIn0.mBFeWNyvadCChBo7VI2PLu7WtgvV_842Xk56A5US4UE'
      let connectOptions = {
        name: _self.appId,
        // logLevel: "debug",
        audio: true,
        video: { width: 120, height: 120 },
      };
      // before a user enters a new room,
      // disconnect the user from they joined already
      _self.leaveRoomIfJoined();
      // remove any remote track when joining a new room
      if(typeof document.getElementById("remoteTrack").innerHTML != undefined){
        document.getElementById("remoteTrack").innerHTML = "";
      }

      Twilio.connect(token, connectOptions).then(function (room) {
        // _self.dispatchLog('Successfully joined a Room: '+ room_name);

        // set active toom
        _self.activeRoom = room;
        _self.roomName = _self.appId;
        // _self.loading = false;
        // Attach the Tracks of all the remote Participants.
        room.participants.forEach(function (participant) {
          let previewContainer = document.getElementById("remoteTrack");
          // VueThis.attachParticipantTracks(participant, previewContainer);
          participant.on("trackSubscribed", (track) =>
            trackSubscribed(previewContainer, track)
          );
          participant.tracks.forEach((publication) => {
            if (publication.isSubscribed) {
              trackSubscribed(previewContainer, publication.track);
            }
          });
        });
         room.on("trackUnsubscribed", trackUnsubscribed);
        // When a Participant joins the Room, log the event.
        room.on("participantConnected", function (participant) {
          let previewContainer = document.getElementById("remoteTrack");
          // VueThis.attachParticipantTracks(participant, previewContainer);
          participant.on("trackSubscribed", (track) => {
            console.log('trackSubscribed',track)
            if(track.mediaStreamTrack&&track.mediaStreamTrack.enabled){
              _self.trackEnabledval = true
            }
            trackSubscribed(previewContainer, track);
          });
          participant.tracks.forEach((publication) => {
            if (publication.isSubscribed) {
              trackSubscribed(previewContainer, publication.track);
            }
          });
        });
        //new added Events  ( sanjith )
        room.on('trackEnabled',trackEnabled)
        function trackEnabled(v){
          console.log(v)
          if(v.kind === 'video')
          _self.trackEnabledval = true
        }
        room.on('trackDisabled', trackDisabled)
        function trackDisabled(v){
          console.log(v)
          if(v.kind === 'video')
          _self.trackEnabledval = false
        }
        room.on('disconnected',disconnected)

         function disconnected(v){
          console.log('disconnected',v)
          let videoTrack = [..._self.activeRoom.localParticipant.videoTracks.values()][0].track;
          console.log('videoTrackvideoTrack',videoTrack)
            videoTrack.mediaStreamTrack.stop()
            videoTrack.detach().forEach((element) => element.remove());
            _self.activeRoom.localParticipant.unpublishTrack(videoTrack); 
            document.getElementById("localTrack").innerHTML = ""
            _self.disconnectCall()
            _self.localTrack = false
            // setTimeout(() => {
            //   track.detach().forEach((element) => element.remove())
            // }, 1000);
        }
        room.once('disconnected', error => room.participants.forEach(disconnectEvent));
        // When a Participant adds a Track, attach it to the DOM.
        room.on("trackAdded", function (track, participant) {
          // alert("trackAdded");
          // _self.dispatchLog(participant.identity + " added track: " + track.kind);
          let previewContainer = document.getElementById("remoteTrack");
          _self.attachTracks([track], previewContainer);
        });

        // When a Participant removes a Track, detach it from the DOM.
        room.on("trackRemoved", function (track, participant) {
          // alert("trackRemoved");
          // _self.dispatchLog(participant.identity + " removed track: " + track.kind);
          _self.detachTracks([track]);
        });

        // When a Participant leaves the Room, detach its Tracks.
        // room.on("participantDisconnected", function(participant) {
        //   alert("participantDisconnected");
        //   //  _self.dispatchLog("Participant '" + participant.identity + "' left the room");
        //   _self.detachParticipantTracks(participant);
        // });
        function disconnectEvent(track){
        if (track != true && track.kind != "data") {
          let videoTrack = [..._self.activeRoom.localParticipant.videoTracks.values()][0].track;
          console.log('videoTrackvideoTrack',videoTrack)
            videoTrack.mediaStreamTrack.stop()
            videoTrack.detach().forEach((element) => element.remove());
            _self.activeRoom.localParticipant.unpublishTrack(videoTrack); 
            document.getElementById("localTrack").innerHTML = ""
            _self.disconnectCall()
            _self.localTrack = false
            // setTimeout(() => {
            //   track.detach().forEach((element) => element.remove())
            // }, 1000);
          }
        }
        // if local preview is not active, create it
        if (!_self.localTrack) {
          createLocalVideoTrack().then((track) => {
            let localMediaContainer = document.getElementById("localTrack");

            localMediaContainer.appendChild(track.attach());
            _self.activeRoom.localParticipant.publishTrack(track);
            _self.localTrack = true;
          });
        }else{
          createLocalVideoTrack().then((track) => {
            _self.activeRoom.localParticipant.publishTrack(track);
          })
        }
      });
      function trackSubscribed(div, track) {
        if (track && track.kind != "data") {
          div.appendChild(track.attach());
        }
      }
     function trackUnsubscribed(track) {
        // if(typeof document.getElementById("remoteTrack").innerHTML != undefined){
        //   document.getElementById("remoteTrack").innerHTML = ""
        // }
        if (track.kind ==="video") {
          // alert(" patient paused")
          track.detach().forEach((element) => element.remove())
          if(track.mediaStreamTrack.enabled === false){
            _self.trackEnabledval = false
          }
          console.log(track)
        }else{
           document.getElementById("remoteTrack").innerHTML = ""
        }
      }
    },
    // Detach the Participant's Tracks from the DOM.
    detachParticipantTracks(participant) {
      let tracks = Array.from(participant.tracks.values());
      this.detachTracks(tracks);
    },
    // Attach the Participant's Tracks to the DOM.
    attachParticipantTracks(participant, container) {
      let tracks = Array.from(participant.tracks.values());
      this.attachTracks(tracks, container);
    },
    // Attach the Tracks to the DOM.
    attachTracks(tracks, container) {
      tracks.forEach(function (track) {
        container.appendChild(track.attach());
      });
    },
    // Detach the Tracks from the DOM.
    detachTracks(tracks) {
      tracks.forEach((track) => {
        track.detach().forEach((detachedElement) => {
          detachedElement.remove();
        });
      });
    },
    nameCaps(pname) {
      if (pname) {
        return (
          pname.charAt(0).toUpperCase() +
          (pname.split(" ")[1]
            ? pname.split(" ")[1].charAt(0).toUpperCase()
            : "")
        );
      }
      return "";
    },
    // send message to patient
    sendMessage() {
      let _self = this;
      if (!(_self.msgText && _self.msgText.trim())) return;
      let msgText = JSON.parse(JSON.stringify(_self.msgText));
      _self.msgText = "";
      if (_self.file_type) {
        _self.triggerCancel = true;
      }
      let msgReq = {
        chatroom_id: _self.appId,
        timestamps: moment.utc().valueOf(),
        body: msgText,
        file_type: _self.file_type,
        from: _self.userInfo.uid,
        msg_type: "text",
        sender_type: 1,
      };
      if (_self.triggerCancel) {
        msgReq.msg_type = "attachment";
      }
      console.log(msgReq,"msgReqmsgReqmsgReqmsgReq")
      _self.chatMsgs.push(msgReq);
      _self.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/chat/message`,
          body: msgReq,
        })
        .then((response) => {
          let msgDsp = _self.$refs.chatArea;
          if(typeof msgDsp != 'undefined' ){
            msgDsp.scrollTop = msgDsp.scrollHeight;
          }
          _self.msgText = "";
          _self.file_type = null;
          _self.triggerCancel = false;
        });
    },
    chatTime(date) {
      return moment(date).format("HH:mm");
    },
    // fetch appointment data if redirection is from notification
    appData: function () {
      let _self = this
      if (_self.$route.params.appid) {
        _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/apt/${_self.$route.params.appid}`,
          query: {}
        })
        .then(response => {
          if (response && response.status === 1000 && response.data) {
            _self.appDetails = response.data;
            _self.pname = _self.appDetails.sanar_uname
            _self.pimg = _self.appDetails.img;
          }
        })
        .catch(e => {
         console.log(e);
        });
      }
    },
    // fetch messages from server if already chat happened
    fetchMessages() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/chat/v6/get_message`,
          body: {
            chatroom_id: _self.appId,
          },
        })
        .then((response) => {
          if (
            response &&
            response.status == "1000" &&
            response.data &&
            response.data.messages
          ) {
            _self.chatMsgs = response.data.messages;
            setTimeout(function () {
              let msgDsp = _self.$refs.chatArea;
              if(typeof msgDsp != 'undefined' ){
                msgDsp.scrollTop = msgDsp.scrollHeight;
              }
            }, 100);
          }
        });
    },
    chatSession() {
      this.chatSessionEnd = !this.chatSessionEnd;
    },
    // fullImage() {
    //   this.fullImageModal = !this.fullImageModal;
    // },
    videoCall() {
      const _self = this;
      let presentTime = moment().tz("Asia/Riyadh").format();
      let appstartTime = moment(
        _self.appDetails.date + _self.appDetails.strt_tym,
        "YYYY-MM-DDThh:mm A"
      )
        .tz("Asia/Riyadh", true)
        .format();
      let appEndTime = moment(appstartTime)
        .add(moment.duration(4, "hours"))
        .tz("Asia/Riyadh")
        .format();
      if (moment(appEndTime).isAfter(moment(presentTime))) {
        _self.dialer = true;
        _self.diallerStartTime = moment().format();
        _self.chatPanel = false;
        _self.headerPanel = false;
        _self.videoPanel = true;
        _self.dialInterval = setInterval(() => {
          _self.calculateDial();
        }, 1000);
        let doctorTwilio = function (callback) {
          _self.$store
            .dispatch("httpPost", {
              uri: `${com_url}/video/create-room`,
              body: {
                username: _self.userInfo.uid,
                roomname: _self.appId,
              },
            })
            .then((data) => {
              if (data && data.token) {
                _self.doctorToken = data.token;
              }
              callback();
            });
        };
        let patientTwilio = function (callback) {
          _self.$store
            .dispatch("httpPost", {
              uri: `${com_url}/video/create-room`,
              body: {
                username: _self.appDetails.sanar_uid,
                roomname: _self.appId,
              },
            })
            .then((data) => {
              if (data && data.token) {
                _self.patientToken = data.token;
              }
              callback();
            });
        };
        async.parallel(
          [doctorTwilio.bind(), patientTwilio.bind()],
          function () {
            if (_self.patientToken && _self.doctorToken) {
              let callPatientReq = {
                uid: _self.appDetails.sanar_uid,
                doc_id: _self.userInfo.uid,
                data: {
                  type: "videocall",
                  roomName: _self.appId,
                  token: _self.patientToken,
                  docName: _self.userInfo.fn + " " + _self.userInfo.ln,
                  docProfile: _self.userInfo.img,
                  sid: _self.socket.id,
                },
              };
              setTimeout(() => {
                  _self.$store
                    .dispatch("httpPost", {
                      uri: `${socket_url}/socket/video_call_v1`,
                      body: callPatientReq,
                    })
                    .then((videoRes) => {
                     // _self.$store.dispatch("SET_NAVIGATE", false);
                      // _self.twilioAPI();
                    });
                }, 2000);
              _self.callInterval = setInterval(() => {
                // buffer time for accept
                setTimeout(() => {
                  _self.$store
                    .dispatch("httpPost", {
                      uri: `${socket_url}/socket/video_call_v1`,
                      body: callPatientReq,
                    })
                    .then((videoRes) => {
                      _self.$store.dispatch("SET_NAVIGATE", false);
                      // _self.twilioAPI();
                    });
                }, 2000);
              }, 7000);
            } else {
              alert("error in initiating video call");
            }
          }
        );
      } else {
        _self.$store.dispatch("SET_ALERTMESSAGE", {
          msg: "Video call session ended",
          class: "sa-a-danger",
        });
      }
    },
    minMax() {
      const _self = this;
      if (!_self.minMaxFlag) {
        // _self.msgTextflag = false
        _self.chatPanel = true;
        _self.minMaxPanel = true;
        _self.minMaxFlag = true;
        setTimeout(function () {
              let msgDsp = _self.$refs.chatArea;
              if(typeof msgDsp != 'undefined' ){
                  msgDsp.scrollTop = msgDsp.scrollHeight;
              }
            }, 100);
      } else {
        _self.msgTextflag = false;
        _self.chatPanel = false;
        _self.minMaxPanel = false;
        _self.minMaxFlag = false;
      }
    },
    localScreen() {
      const _self = this;
      if (!_self.screenSize) {
        _self.screenSize = true;
      } else {
        _self.screenSize = true;
      }
    },
    remoteScreen() {
      const _self = this;
      if (!_self.screenSize) {
        _self.screenSize = false;
      } else {
        _self.screenSize = false;
      }
    },
    // agora changes
    startCall() {
      this.$store
        .dispatch("httpPost", {
          uri: `${com_url}/videocall/get-access-token`,
          body: {
            username: this.appDetails.sanar_uid,
            roomname: this.appId,
          },
        })
        .then(res => {
          console.log('res : ', res);
          if(res.status==1000) {
            this.$store.dispatch("SET_RINGING", true);
            const VIDEOCALL_PAYLOAD = {
              provider: res.data.provider,
              providerId: res.data.providerId,
              token: res.data.token,
              roomName: this.appId,
              docName: this.userInfo.fn + " " + this.userInfo.ln,
              docProfile: this.userInfo.img,
              name: this.appDetails.sanar_uid,
              sid: this.socket.id,
              uid: this.appDetails.sanar_uid,
              virtualBGDoc: res.data.virtualBGDoc||'false',
              virtualBGUsr: res.data.virtualBGUsr||'false'
            }
            this.$store.dispatch("SET_VIDEOCALL_PAYLOAD", VIDEOCALL_PAYLOAD);
            const videocallRequestBody = {
              uid: this.appDetails.sanar_uid,
              doc_id:this.userInfo.uid,
              data: {
                type: 'videocall',
                roomName: this.appId,
                token: res.data.token,
                docName: this.userInfo.fn + " " + this.userInfo.ln,
                docProfile: this.userInfo.img,
                name: this.appDetails.sanar_uid,
                sid: this.socket.id,
                uid: this.appDetails.sanar_uid,
                providerId: res.data.providerId,
                provider: res.data.provider,
                virtualBGDoc: res.data.virtualBGDoc,
                virtualBGUsr: res.data.virtualBGUsr
              }
            }
            
            this.$store
              .dispatch('httpPost', {
                uri: `${socket_url}/socket/video_call_v1`,
                body: videocallRequestBody
              });
          } else {
            console.log('no response');
          }
        })
        .catch( err => {
          console.log('on start call error : ', err);
        })
    },
    endCall() {
      const rejectPayload = {
        uid: this.appDetails.sanar_uid,
        apnt_id:this.appDetails.apnt_id
      }
      this.$store.dispatch('httpPost', {
        uri: `${socket_url}/socket/reject_video_call_v1`,
        body: rejectPayload
      }).then(res => console.log);
      this.$store.dispatch("SET_RINGING", false);
      this.$store.dispatch("SET_CALL_STATUS", 'disconnected');
      this.$store.dispatch("SET_VIDEOCALL_PAYLOAD", null);
    },
    onCallAccept(payload) {
      console.log('on call accept : ', payload);
      this.$store.dispatch("SET_RINGING", false);
      this.$store.dispatch("SET_CALL_STATUS", 'connected');
    }
  },
};
</script>
